module.exports = __webpack_public_path__ + "02_very_short_brown.926f9508.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_very_short_brown.png
// module id = EISy
// module chunks = 0